import * as React from 'react';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { LoadingButton } from '@mui/lab';

import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import {
  Box,

  FormControl,

  InputLabel,
  MenuItem,
  Select,
  Stack,
} from '@mui/material';
import { addAdminUser, updateAdminUser } from '../../api/superadmin';

const initialState = {
  firstName: '',
  lastName: '',
  email: '',
  role: '',
  roleId: '',
  departmentIds: [],
  rooms: [],
  contactNo: '',
  city: '',
  state: '',
  country: '',
  zip: '',
};

export default function RestaurantUserDialog({
  dialogOpen,
  setDialogOpen,
  selectedItem,
  action,
  setSnackbarMessage,
  setSnackbarOpen,
  fetchData,
}) {


  const [inputs, setInputs] = useState(initialState);

  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault()

    setIsLoading(true)

    try {
      const { data } = action === 'CREATE' ? await addAdminUser(inputs) : await updateAdminUser(inputs,selectedItem._id, )
      if (data.success) {
        fetchData();
        setIsLoading(false);
        setSnackbarMessage({ msg: data.message, success: true });
        setSnackbarOpen(true);
        setDialogOpen(false);

      } else {
        setIsLoading(false);
        setSnackbarMessage({ msg: data.message, success: false });
        setSnackbarOpen(true);
      }
    } catch (error) {
      setIsLoading(false);
      setSnackbarMessage({ msg: error.message, success: false });
      setSnackbarOpen(true);
    }
  };

  const handleInputChange = (e) => {
    setInputs({ ...inputs, [e.target.name]: e.target.value })
  };

  const handleSelectRole = (event) => {
    setInputs({ ...inputs, roleId: event.target.value })
  };

  const handleClose = () => {
    setDialogOpen(false);
  };

  useEffect(() => {
    // console.log('in hook', services.filter((item) => selectedItem.departmentIds.includes("6503e2a7f2e335eb18e1fc24")));
    if (action !== 'CREATE') {
      // console.log('am in', selectedItem, services);
      setInputs({
        firstName: selectedItem.firstName,
        lastName: selectedItem.lastName,
        email: selectedItem.email,
       
        contactNo: selectedItem.contactNo,
        city: selectedItem.city,
      })

    }
    else {
      setInputs({ ...initialState });

    }
  }, [dialogOpen])

  return (
    <Box>
      <Dialog open={dialogOpen} onClose={handleClose}>
        <DialogTitle>{action === 'CREATE' ? 'Create Admin User' : 'Edit Admin User'} </DialogTitle>
        <form onSubmit={handleSubmit}>
          <DialogContent >

            <TextField
              autoFocus
              margin="dense"
              name="firstName"
              label="First Name"
              type="text"
              fullWidth
              variant="standard"
              value={inputs.firstName}
              onChange={handleInputChange}
              required
            />

            <TextField

              margin="dense"
              name="lastName"
              label="Last Name"
              type="text"
              fullWidth
              variant="standard"
              value={inputs.lastName}
              onChange={handleInputChange}
              required

            />

            <TextField
              margin="dense"
              name="email"
              label="Email"
              type="email"
              fullWidth
              variant="standard"
              value={inputs.email}
              onChange={handleInputChange}
              required

            />
            <TextField
              margin="dense"
              name="contactNo"
              label="Phone"
              inputProps={{ maxLength: 10 , minLength:10, pattern:"[0-9]{10}"}}
              fullWidth
              variant="standard"
              value={inputs.contactNo}
              onChange={handleInputChange}
              required
            />
         

          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} variant='contained' >Cancel</Button>
            <LoadingButton loading={isLoading} type='submit' variant='contained' >{action === 'CREATE' ? 'Create' : 'Update'}</LoadingButton>
          </DialogActions>
        </form>
      </Dialog>
    </Box>
  )
}
